import { Mail, BookMarked, ArrowUpRight } from "lucide-react";
import { LINKS, ASSETS } from "../data/content";

const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const IgIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
);

const TgIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
);

const socials = [
  { name: "X", href: LINKS.x, Icon: XIcon, id: "footer-x-link" },
  { name: "Instagram", href: LINKS.instagram, Icon: IgIcon, id: "footer-instagram-link" },
  { name: "Telegram", href: LINKS.telegram, Icon: TgIcon, id: "footer-telegram-link" },
  { name: "Email", href: LINKS.email, Icon: Mail, id: "footer-email-link" },
];

const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative bg-[#0a0a0a] text-white pt-20 pb-10 overflow-hidden"
  >
    <div className="paper-noise absolute inset-0 opacity-[0.03] pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 md:px-8">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <div className="flex items-center gap-3">
            <img src={ASSETS.logo} alt="Essay Advantage Club" className="h-14 w-14 rounded-full" />
            <span className="font-display font-extrabold text-2xl tracking-tight">
              ESSAY Advantage Club
            </span>
          </div>
          <p className="mt-5 text-white/60 max-w-md leading-relaxed">
            30 Days. 5 Weeks. 1 Mission. Transform your essay writing from
            average to UPSC topper level — with personal evaluation every step
            of the way.
          </p>
          <a
            href={LINKS.handbook}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-handbook-link"
            className="btn-3d-dark group mt-7 inline-flex items-center gap-2 bg-white text-[#0a0a0a] font-extrabold text-sm px-6 py-3.5 rounded-2xl"
          >
            <BookMarked className="h-4 w-4" />
            UPSC Mains Ans Writing Advantage Handbook
            <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>

        <div className="md:col-span-6 md:text-right">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#8ee85a]">
            Follow the journey
          </p>
          <div className="mt-5 flex md:justify-end gap-3 flex-wrap">
            {socials.map(({ name, href, Icon, id }) => (
              <a
                key={name}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={id}
                aria-label={name}
                className="group h-12 w-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#58cc02] hover:border-[#58cc02] transition-colors duration-200"
              >
                <Icon className="h-5 w-5 text-white" />
              </a>
            ))}
          </div>
          <a
            href={LINKS.email}
            data-testid="footer-email-text"
            className="mt-5 inline-block text-white/60 hover:text-white transition-colors font-semibold"
          >
            {LINKS.emailPlain}
          </a>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-display font-extrabold text-lg tracking-tight">
          @UPSCWithArpita
        </p>
        <p className="text-white/40 text-sm">
          © {new Date().getFullYear()} Essay Advantage Club · Built for UPSC CSE aspirants.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
